import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import constants from "../src/assets/js/constants";

Vue.use(VueI18n);

function loadLocaleMessages() {
	return new Promise((resolve, reject) => {
		let messages = {};
		if (window.getLocalizedResourcesFromJsonFiles == true) 
		{
			let locals = [require.context("./locals", true, /[A-Za-z0-9-_,\s]+\.json$/i)];
			for (let i = 0; i < locals.length; i++) 
			{
				let local = locals[i];
				if (local == "") continue;
				for (let j = 0; j < local.keys().length; j++) {
					const matched = local
						.keys()
						[j].match(/([A-Za-z0-9-_]+)\./i);
					if (matched && matched.length > 1) {
						const locale = matched[1];
						if (!messages[locale])
							messages[locale] = local(local.keys()[j]);
						else
							messages[locale] = {
								...messages[locale],
								...local(local.keys()[j]),
							};
					}
				}
			}
			resolve({ en: messages.en, ar: messages.ar });
		} 
		else 
		{
			axios.get(`${constants.baseApiUrl}Resources/NoCache`)
				.then((response) => {
					messages =
						response.data == ""
							? { en: {}, ar: {} }
							: response.data;
					resolve(messages);
				})
				.catch((error) => {
					console.error(
						"Error loading localization messages:",
						error
					);
					reject(error);
				});
		}
	});
}

const i18n = new VueI18n({
	locale: defaultApplicationLanguage,
	fallbackLocale: defaultApplicationLanguage,
	messages: {},
});

loadLocaleMessages()
	.then((loadedMessages) => {
		const storedLanguage = localStorage.getItem("lang");
		const activeLocale = loadedMessages[storedLanguage]
			? storedLanguage
			: defaultApplicationLanguage;

		i18n.setLocaleMessage(activeLocale, loadedMessages[activeLocale]);
		i18n.locale = activeLocale;
	})
	.catch((error) => {
		console.error("Failed to load localization messages:", error);
	});

export default i18n;
